<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 4845 632"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <path
      id="tassel-primary-color"
      d="M5.143,10.591l92.517,12.067c2.683,0.341 4.583,2.816 4.225,5.491c-0.35,2.692 -2.817,4.584 -5.5,4.242l-91.242,-11.908l0,-9.892Zm0,69.792l146.025,5.4c2.725,0.108 4.85,2.358 4.734,5.066c-0.092,2.734 -2.375,4.842 -5.084,4.759l-145.675,-5.409l0,-9.816Zm275.384,-11.309l-275.384,-3.216l0,-9.817l275.384,3.217l-0,9.816Zm-0,80.859l-275.384,5.308l0,-9.817l275.384,-5.308l-0,9.817Zm-0,78.558l-275.384,-5.317l0,-9.816l275.384,5.316l-0,9.817Zm-0,67.367l-249.35,-15.242l-26.034,26.05l0,-13.942l20.642,-20.625l0.017,0c0.95,-0.95 2.291,-1.508 3.75,-1.433l250.975,15.342l-0,9.85Zm-0,36l-234.092,-3.142c-2.708,-0.033 -4.883,-2.267 -4.858,-4.958c0.05,-2.717 2.266,-4.892 4.966,-4.85l233.984,3.133l-0,9.817Zm-0,35.758l-266.325,-2.108l1.033,7.691l50.033,4.275c2.709,0.209 4.717,2.6 4.5,5.309c-0.208,2.708 -2.616,4.716 -5.308,4.508l-53.967,-4.617l0,-0.008c-2.283,-0.175 -4.183,-1.908 -4.475,-4.25l-0.875,-6.542l0,-14.816c0.909,-0.884 2.142,-1.417 3.492,-1.409l271.892,2.134l-0,9.833Zm-0,76.733l-275.05,-7.541l-0,18.6l156.866,-4.442c2.717,-0.075 4.967,2.058 5.042,4.783c0.083,2.7 -2.058,4.959 -4.775,5.034l-157.467,4.475l0,-38.292l275.384,7.575l-0,9.808Zm-0,38.392l-160.517,1.008c-2.725,0.017 -4.917,-2.175 -4.95,-4.9c0,-2.708 2.2,-4.908 4.908,-4.925l160.559,-1l-0,9.817Zm-275.384,122.217l138,-27.6c0.25,-0.05 0.509,-0.084 0.775,-0.092l136.609,-14.567l-0,5.034l38.825,-0c-0.7,0.533 -1.525,0.875 -2.467,0.975l-171.925,18.341l-139.817,27.959l0,-10.05Zm275.384,-83.284l-275.384,1.084l0,-9.825l275.384,-1.075l-0,9.816Zm-275.384,7.75l174.834,9.959c2.725,0.15 4.783,2.466 4.633,5.191c-0.15,2.684 -2.467,4.784 -5.167,4.634l-174.3,-9.934l0,-9.85Zm4843.83,112.366l-92.516,-12.066c-2.684,-0.334 -4.584,-2.817 -4.225,-5.492c0.35,-2.692 2.816,-4.583 5.5,-4.242l91.241,11.917l0,9.883Zm0,-69.783l-146.025,-5.4c-2.725,-0.117 -4.85,-2.367 -4.733,-5.075c0.092,-2.725 2.375,-4.842 5.083,-4.758l145.675,5.416l0,9.817Zm-275.383,11.308l275.383,3.209l0,9.816l-275.383,-3.216l0,-9.809Zm0,-80.866l275.383,-5.309l0,9.817l-275.383,5.308l0,-9.816Zm0,-78.559l275.383,5.325l0,9.809l-275.383,-5.309l0,-9.825Zm0,-67.366l249.342,15.241l26.041,-26.05l0,13.942l-20.633,20.633l-0.025,0c-0.942,0.942 -2.292,1.5 -3.75,1.425l-250.975,-15.333l0,-9.858Zm0,-35.992l234.1,3.142c2.708,0.025 4.883,2.258 4.858,4.95c-0.041,2.716 -2.275,4.891 -4.966,4.858l-233.992,-3.133l0,-9.817Zm0,-35.758l266.333,2.1l-1.033,-7.692l-50.042,-4.275c-2.708,-0.208 -4.716,-2.6 -4.5,-5.308c0.217,-2.7 2.617,-4.717 5.317,-4.509l53.958,4.617l0,0.008c2.284,0.175 4.192,1.925 4.484,4.25l0.866,6.542l0,14.817c-0.908,0.883 -2.133,1.416 -3.483,1.408l-271.9,-2.133l0,-9.825Zm0,-76.742l275.067,7.542l-0,-18.6l-156.884,4.45c-2.708,0.066 -4.966,-2.067 -5.033,-4.792c-0.092,-2.692 2.05,-4.958 4.775,-5.033l157.458,-4.475l0,38.291l-275.383,-7.566l0,-9.817Zm0,-38.392l160.517,-1.008c2.725,-0.017 4.925,2.175 4.958,4.908c0,2.7 -2.208,4.9 -4.917,4.917l-160.558,1l0,-9.817Zm275.383,-122.216l-137.991,27.608c-0.25,0.042 -0.509,0.075 -0.784,0.083l-136.608,14.567l0,-5.033l-38.825,-0c0.708,-0.534 1.525,-0.875 2.475,-0.975l171.917,-18.325l139.816,-27.975l0,10.05Zm-275.383,83.283l275.383,-1.075l0,9.817l-275.383,1.075l0,-9.817Zm275.383,-7.75l-174.825,-9.958c-2.733,-0.15 -4.783,-2.467 -4.641,-5.192c0.15,-2.683 2.466,-4.775 5.166,-4.633l174.3,9.933l0,9.85Z"
      :style="{
        fill: productColors.secondary_1.value,
        transition: 'all 500ms',
      }"
    />
    <path
      id="tassel-seconday-color"
      d="M5.143,29.474l19.334,8.05l103.458,-2.267c2.717,-0.05 4.95,2.092 4.992,4.808c0.058,2.717 -2.092,4.942 -4.784,5.009l-104.233,2.283l-18.767,-17.883Zm275.384,73.7l-138,-12.159c-2.7,-0.241 -4.7,-2.641 -4.475,-5.333c0.233,-2.725 2.616,-4.733 5.325,-4.5l137.15,12.1l-0,9.892Zm-267.192,30.316c-2.717,0.067 -4.983,-2.05 -5.058,-4.783c-0.067,-2.692 2.075,-4.967 4.783,-5.033l267.467,-8.267l-0,9.842l-267.192,8.241Zm-8.192,-33.408l91.192,8.683c2.7,0.259 4.683,2.659 4.425,5.35c-0.258,2.692 -2.65,4.692 -5.342,4.425l-90.275,-8.6l0,-9.858Zm0,74.175l120.85,6.833c2.717,0.15 4.8,2.467 4.659,5.175c-0.159,2.709 -2.484,4.8 -5.192,4.642l-120.317,-6.808l0,-9.842Zm275.384,-1.833l-121.242,6.991c-2.7,0.167 -5.017,-1.933 -5.15,-4.633c-0.15,-2.717 1.933,-5.025 4.642,-5.167l121.75,-7.041l-0,9.85Zm-0,27.15l-274.092,8.575c-0.45,-0 -0.875,-0.059 -1.292,-0.142l0,-9.55c0.334,-0.083 0.659,-0.133 1.017,-0.133l274.367,-8.584l-0,9.834Zm-0,59.116l-275.384,0l0,-9.866l275.384,-0l-0,9.866Zm-267.359,40.184c-2.716,-0 -4.916,-2.209 -4.916,-4.917c-0,-2.725 2.2,-4.933 4.916,-4.933l155.059,-0c2.708,-0 4.925,2.208 4.925,4.933c-0,2.708 -2.217,4.917 -4.925,4.917l-155.059,-0Zm-8.025,31.108l109.45,15.317l165.934,-3.034l-0,9.825l-165.925,3.042c-0.342,0.017 -0.675,-0 -1.042,-0.042l-108.417,-15.183l0,-9.925Zm275.384,68.008l-155.85,3.084c-2.709,0.041 -4.95,-2.117 -5,-4.825c-0.042,-2.7 2.1,-4.967 4.808,-5.009l156.042,-3.058l-0,9.808Zm-275.384,3.367l111.767,19.725l163.617,-6.783l-0,9.841l-163.459,6.759c-0.433,0.066 -0.9,0.05 -1.358,-0.042l-110.567,-19.5l0,-10Zm275.384,66.808l-275.384,7.367l0,-9.833l275.384,-7.359l-0,9.825Zm-275.384,15.4l159.934,23.65l115.45,-5.1l-0,9.825l-115.242,5.092c-0.392,0.05 -0.792,0.042 -1.233,-0.017l-158.909,-23.508l0,-9.942Zm0,100.509l39.1,-20.042c0.809,-0.392 1.684,-0.558 2.517,-0.525l0,-0.008l125.175,6.891c2.7,0.159 4.783,2.467 4.642,5.175c-0.142,2.717 -2.467,4.784 -5.184,4.642l-123.866,-6.808l-42.384,21.7l0,-11.025Zm4843.83,38.834l-19.333,-8.05l-103.458,2.266c-2.725,0.05 -4.95,-2.091 -4.992,-4.8c-0.058,-2.725 2.092,-4.941 4.783,-5.008l104.234,-2.292l18.766,17.884Zm-275.383,-73.7l138,12.158c2.7,0.25 4.7,2.642 4.475,5.333c-0.233,2.734 -2.617,4.734 -5.325,4.509l-137.15,-12.092l0,-9.908Zm267.192,-30.317c2.716,-0.067 4.983,2.05 5.058,4.792c0.067,2.683 -2.075,4.958 -4.783,5.025l-267.467,8.266l0,-9.841l267.192,-8.242Zm8.191,33.408l-91.191,-8.683c-2.7,-0.25 -4.684,-2.658 -4.425,-5.35c0.258,-2.692 2.65,-4.692 5.341,-4.425l90.275,8.608l0,9.85Zm0,-74.175l-120.85,-6.833c-2.716,-0.15 -4.8,-2.458 -4.666,-5.175c0.166,-2.708 2.491,-4.8 5.2,-4.633l120.316,6.8l0,9.841Zm-275.383,1.834l121.242,-6.992c2.7,-0.158 5.016,1.933 5.15,4.633c0.15,2.717 -1.934,5.034 -4.642,5.167l-121.75,7.05l0,-9.858Zm0,-27.142l274.092,-8.583c0.45,-0 0.875,0.066 1.291,0.15l0,9.541c-0.325,0.092 -0.658,0.142 -1.016,0.142l-274.367,8.575l0,-9.825Zm0,-59.125l275.383,0l0,9.875l-275.383,0l0,-9.875Zm267.367,-40.183c2.716,-0 4.916,2.208 4.916,4.925c0,2.716 -2.2,4.933 -4.916,4.933l-155.059,0c-2.716,0 -4.933,-2.217 -4.933,-4.933c0,-2.717 2.217,-4.925 4.933,-4.925l155.059,-0Zm8.016,-31.109l-109.45,-15.316l-165.933,3.033l0,-9.825l165.925,-3.033c0.342,-0.017 0.675,-0.009 1.042,0.041l108.416,15.184l0,9.916Zm-275.383,-68l155.858,-3.091c2.709,-0.042 4.942,2.125 4.992,4.825c0.05,2.7 -2.092,4.966 -4.808,5.008l-156.042,3.058l0,-9.8Zm275.383,-3.375l-111.758,-19.725l-163.625,6.784l0,-9.834l163.458,-6.758c0.442,-0.075 0.909,-0.05 1.367,0.033l110.558,19.5l0,10Zm-275.383,-66.808l275.383,-7.367l0,9.834l-275.383,7.358l0,-9.825Zm275.383,-15.4l-159.933,-23.65l-115.45,5.108l0,-9.833l115.242,-5.092c0.391,-0.05 0.791,-0.041 1.241,0.017l158.9,23.508l0,9.942Zm0,-100.508l-39.1,20.041c-0.808,0.392 -1.675,0.559 -2.516,0.525l-0,0.017l-125.184,-6.892c-2.691,-0.166 -4.766,-2.475 -4.625,-5.183c0.134,-2.708 2.467,-4.783 5.175,-4.642l123.875,6.809l42.375,-21.7l0,11.025Z"
      :style="{
        fill: productColors.secondary_2.value,
        transition: 'all 500ms',
      }"
    />
    <g
      id="scarf-primary-color"
      transform="matrix(8.33333,0,0,8.33333,3600.17,588.429)"
    >
      <rect
        x="-398.356"
        y="-64.298"
        width="515.152"
        height="64.298"
        :style="{
          fill: productColors.primary_1.value,
          transition: 'all 500ms',
          fillRule: 'nonzero',
          stroke: '#cecece',
          strokeWidth: '1',
        }"
      />
    </g>
    <g id="scarf-tertiary-color" transform="matrix(1,0,0,1,-1119.6,-13248)">
      <path
        d="M2466.9,13504.5l0,28.666l-1066.76,0l-0,-28.666l1066.76,-0Zm0,115.516l0,28.667l-1066.76,0l-0,-28.667l1066.76,0Zm3230.38,-115.516l0,28.666l-1066.76,0l-0,-28.666l1066.76,-0Zm0,115.516l0,28.667l-1066.76,0l-0,-28.667l1066.76,0Z"
        :style="{
          fill: productColors.primary_2.value,
          transition: 'all 500ms',
        }"
      />
    </g>
    <g id="scarf-secondary-color" transform="matrix(1,0,0,1,-1119.6,-13248)">
      <path
        d="M2466.9,13552.7l0,47.892l-1066.76,0l-0,-47.892l1066.76,0Zm3230.38,0l0,47.892l-1066.76,0l-0,-47.892l1066.76,0Z"
        :style="{
          fill: productColors.secondary_1.value,
          transition: 'all 500ms',
        }"
      />
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip2">
      <rect
        id="text-mask"
        x="1361.42"
        y="60.752"
        width="2149.57"
        height="509.44"
        style="fill: none"
      />
    </clipPath>
    <g
      xmlns="http://www.w3.org/2000/svg"
      clip-path="url(#_clip2)"
      v-if="text.type !== 'front'"
    >
      <g id="text-mask1" serif:id="text-mask">
        <g transform="matrix(250,0,0,250,3066.32,453.67)"></g>
        <text
          id="custom-text-2"
          x="2450px"
          y="441.478px"
          text-anchor="middle"
          :style="{
            fontSize: `${text.size}px`,
            fill: text.color.value,
            transition: 'all 500ms',
            fontFamily: `${text.font}`,
          }"
        >
          {{ text.message2 }}
        </text>
        <g transform="matrix(125,0,0,125,2865.91,237.017)"></g>
        <text
          id="custom-text"
          x="2455px"
          y="225.233px"
          text-anchor="middle"
          :style="{
            fontSize: `${text.size - 120}px `,
            fill: text.color.value,
            transition: 'all 500ms',
            fontWeight: 700,
            fontFamily: `${text.font}`,
          }"
        >
          {{ text.message }}
        </text>
      </g>
    </g>
    <defs>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "Scarf_1_back",
  props: ["productColors", "logo", "text"],
  setup(props) {
    const fontFace = computed(() => getFontFace(props.text.font));
    return {
      fontFace,
    };
  },
};
</script>
